import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useMemo } from 'react';

import { catalogUpdateOtherCostTemplateGql } from '../catalogUerOtherCostTemplatesQueries';

interface IUseEditOtherCostTemplateItem {
    onSuccessHandler: () => void;
}

export const useEditOtherCostTemplateItem = ({ onSuccessHandler }: IUseEditOtherCostTemplateItem) => {
    const [
        otherCostTemplateEditData,
        otherCostTemplateEditStatus,
        otherCostTemplateEditError,
        otherCostTemplateEditRequest,
    ] = useRequest({
        requestId: 'otherCostTemplateEdit',
        query: catalogUpdateOtherCostTemplateGql,
        withEffect: false,
        dependenciesUpdater: onSuccessHandler,
    });
    const [resetotherCostTemplatesEditData] = useResetStoreData({ requestId: 'otherCostTemplateEdit' });

    const isSavingInProgress = useMemo(
        () => otherCostTemplateEditStatus === RequestStatus.FETCHING,
        [otherCostTemplateEditStatus],
    );

    const resetEditData = useCallback(() => {
        resetotherCostTemplatesEditData(null);
    }, [resetotherCostTemplatesEditData]);

    return {
        resetEditData,
        otherCostTemplateEditData: otherCostTemplateEditData?.updateCatalogUEROtherCostTemplate,
        otherCostTemplateEditStatus,
        otherCostTemplateEditError,
        otherCostTemplateEditRequest,
        isSavingInProgress,
    };
};
